import jwtDecode from "jwt-decode";
import { BiSolidMessageSquareCheck } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import useRefreshToken from "../../hooks/useRefreshToken";
import { useEffect } from "react";


const SuccessPayment = ({ title, code }) => {

     const navigate = useNavigate()

     // const token = JSON.parse(localStorage.getItem('user'))
     // const readToken = token?.a ? jwtDecode(token.a) : false

     const refresh = useRefreshToken()

     useEffect(() => {
          const verifyRefreshToken = async () => await refresh()
          verifyRefreshToken()
          // if (readToken && !(readToken.role).includes('BUYER')) verifyRefreshToken()
     }, [code])

     return (
          <>
               <div className="paymentPage">
                    <BiSolidMessageSquareCheck />
                    <div className="contentPaid">
                         <h2>{title}</h2>
                         <p>شما میتوانید برای دانلود فایل یا بررسی تاریخچه سفارشات وارد حساب کاربری خود شوید.</p>
                         <p>باتشکر از خرید شما!</p>
                         <p>کد پیگیری : {code}</p>
                    </div>

                    <div className="flex gap-3">
                         <button className="btnS" onClick={() => navigate('/orders')}>ورود به حساب کاربری</button>
                         <a className="btnS" href={'https://t.me/STM_WEB'} target="_blank">پشتیبانی تلگرام</a>
                    </div>
               </div>
          </>
     );
}

export default SuccessPayment;